import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModelInvoice } from 'src/app/entities/invoices';
import { SezionaliProps } from 'src/app/entities/various';

import { InvoicesSummaryService } from 'src/app/services/invoicesummary/invoicesummary.service';
import { Observable} from 'rxjs';
import { Router,Event,NavigationStart } from '@angular/router';


@Component({
  selector: 'app-barra-riepilogo',
  templateUrl: './barra-riepilogo.component.html',
  styleUrls: ['./barra-riepilogo.component.css']
})

export class BarraRiepilogoComponent implements OnInit{ //, OnChanges 
  
  public model: InvoicesSummaryService;


  constructor(private InvoicesSummaryService : InvoicesSummaryService,private router: Router) { 
    this.model=InvoicesSummaryService;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) { 
          this.model.resetData();
      }
      });
   }

  //inserire costruttore su model
  async ngOnInit() {
    this.model=this.InvoicesSummaryService;
  }

  public totalePagamento(){
    let totale=0;
    if(this.model.getSummary() != undefined){
    if(this.model.getSummary()!.FatturaElettronicaBody.DatiPagamento.length){
      for(var i=0; i< this.model.getSummary()!.FatturaElettronicaBody.DatiPagamento.length; i++){
        totale += (Number.parseFloat(this.model.getSummary()!.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.ImportoPagamento));
      }
      return totale.toFixed(2).toString();
    }
    }
    return "0.00";
  }


  public FormatNumber(value :Number|string){
    if(typeof value === 'string')
      return parseFloat(value).toFixed(2);
    else
      return value.toFixed(2);
  }

}